import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import {
  catalogSuppliersQueryOptions,
  weddingSuppliersQueryOptions,
} from '@/features/suppliers/api'
import { SuppliersWorkspace } from '@/features/suppliers/pages/suppliers-workspace'
import { workspaceQueryOptions } from '@/lib/workspace'

export const Route = createFileRoute(
  '/_auth/w/$workspaceSlug/suppliers/catalog/$catalogSupplierId',
)({
  loader: async ({ context, params }) => {
    await Promise.all([
      context.queryClient.ensureQueryData(catalogSuppliersQueryOptions(params.workspaceSlug)),
      context.queryClient.ensureQueryData(weddingSuppliersQueryOptions(params.workspaceSlug)),
    ])
  },
  component: CatalogSupplierRoute,
})

function CatalogSupplierRoute() {
  const { workspaceSlug, catalogSupplierId } = Route.useParams()
  const workspace = useQuery(workspaceQueryOptions(workspaceSlug))
  return (
    <SuppliersWorkspace
      workspaceSlug={workspaceSlug}
      selectedCatalogSupplierId={catalogSupplierId}
      canWrite={workspace.data?.role !== 'viewer'}
    />
  )
}
